import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3 sm:grid-cols-1" }

import { InputRow, Combobox, MultiCombobox } from '@/components/ui/form';
    import { computed, watch } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { today, getLocalTimeZone } from '@internationalized/date';
    import { useSalaryEmployeeData } from '@/composables/useSalaryEmployeeData';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PayrollForm',
  props: {
    form: {},
    selectedCompanyId: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t, locale, messages } = useI18n();

    const { employeesOptions, isPendingEmployeesOptions } = useSalaryEmployeeData(
        props.selectedCompanyId,
    );

    const typeOptions = computed(() => {
        const types = (messages.value[locale.value] as any).salary.excel.types;

        return Object.entries(types).map(([key, label]) => ({
            value: key,
            label: label as string,
        }));
    });

    const monthOptions = computed(() => {
        const months = (messages.value[locale.value] as any).salary.sheets.months;

        return Object.entries(months).map(([key, label]) => ({
            value: Number(key),
            label: label as string,
        }));
    });

    const yearOptions = computed(() => {
        const currentYear = today(getLocalTimeZone()).year;

        return Array.from({ length: 2 }, (_, i) => currentYear - i).map((year) => ({
            value: year,
            label: year.toString(),
        }));
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "type",
      label: "salary.payroll.type"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Combobox), {
          modelValue: _ctx.form.type,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.type) = $event)),
          options: typeOptions.value,
          placeholder: _unref(t)('salary.payroll.type'),
          "show-remove-button": false
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "month",
      label: "salary.payroll.month"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Combobox), {
          modelValue: _ctx.form.month,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.month) = $event)),
          options: monthOptions.value,
          placeholder: _unref(t)('salary.payroll.month'),
          "show-remove-button": false
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "year",
      label: "salary.payroll.year"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Combobox), {
          modelValue: _ctx.form.year,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.year) = $event)),
          options: yearOptions.value,
          placeholder: _unref(t)('salary.payroll.year'),
          "show-remove-button": false
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    (_ctx.form.type === 'extra')
      ? (_openBlock(), _createBlock(_unref(InputRow), {
          key: 0,
          form: _ctx.form,
          name: "employeeIds",
          label: "salary.payroll.employees"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MultiCombobox), {
              modelValue: _ctx.form.employeeIds,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.employeeIds) = $event)),
              options: _unref(employeesOptions),
              placeholder: _unref(t)('salary.payroll.employees'),
              loading: _unref(isPendingEmployeesOptions),
              "label-by": "full_name",
              "value-by": "id"
            }, null, 8, ["modelValue", "options", "placeholder", "loading"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true)
  ]))
}
}

})